import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth';
import { BoardPermissionsService } from 'src/app/shared/services/board-permissions.service';

@Component({
  selector: 'app-up-board-manager',
  templateUrl: './up-board-manager.component.html',
  styleUrls: ['./up-board-manager.component.css']
})
export class UpBoardManagerComponent implements OnInit {
  boardId: string | null = null;
  showDelivery: boolean = true;

  constructor(
    public auth: AngularFireAuth,
    public authService: AuthService,
    private route: ActivatedRoute,
    public boardPermissions: BoardPermissionsService,
    public router: Router,
    private db: AngularFirestore,
  ) { }


  ngOnInit(): void {
    this.auth.user.subscribe(u => {
      if (!u || !u.email) return;
      this.boardId = this.route.snapshot.paramMap.get('id');

      if (!this.boardId) return;
      this.boardPermissions.init(this.boardId, u.email);
      if (!this.boardPermissions.userHasEditPermissions(this.boardPermissions.boardUser)) {
        this.router.navigate([`/boards/${this.boardId}/view`]);
      }

      // Subscribe to board config for showDelivery flag
      // Deliveries require instore channel to be purchased AND enabled AND showDelivery enabled
      this.db.collection('boards')
        .doc<any>(this.boardId)
        .valueChanges()
        .subscribe((boardDoc) => {
          const instorePurchased = boardDoc?.config?.instoreChannelPurchased !== false;
          const instoreEnabled = boardDoc?.config?.enableInstoreChannel !== false;
          const deliveryEnabled = boardDoc?.config?.showDelivery !== false;
          this.showDelivery = instorePurchased && instoreEnabled && deliveryEnabled;
        });
    });
  }

}
